module.exports = "<span class=\"name\" [ngClass]=\"{'checked': checked}\">{{criteria}}</span>"


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/pcl-criteria-icon/pcl-criteria-icon.component.html
// module id = ./src/app/reports/pcl-criteria-icon/pcl-criteria-icon.component.html
// module chunks = main